import { Component } from '@angular/core';
import { MeasurementContext } from 'src/app/shared/data/engineering-enums';
import { EngineeringToolsApiService } from 'src/app/shared/services/engineering-tools-api';
import { UnitConverterService } from 'src/app/shared/services/unit-converter.service';

@Component({
  selector: 'app-refrigerant-properties',
  templateUrl: './refrigerant-properties.component.html',
  styleUrl: './refrigerant-properties.component.scss',
  standalone: false
})
export class RefrigerantPropertiesComponent {
  constructor(
    private api: EngineeringToolsApiService,
    private unitConverter: UnitConverterService
  ) { }

  public MeasurementContext = MeasurementContext; 

  viewModel: any = {};
  isLoaded: boolean = false;
  isUsUnits: boolean = true;

}
